module.exports = __webpack_public_path__ + "media/media/cases/cases-step-ee5d9ed589614ec6959c9acda810e772.jpg";